/** @file dock-manager/BlackoutOverlay.jsx — full-height diagonal overlay for a blackout. */
import { BLACKOUT_ROLE_STYLE } from "@/lib/constants";

export default function BlackoutOverlay({ blackout, start, end, left, top, rowHeight, fullHeight, pxPerHour }) {
  const s = new Date(blackout.start_time);
  const e = new Date(blackout.end_time);
  const visStart = s < start ? start : s;
  const visEnd = e > end ? end : e;
  if (visEnd <= visStart) return null;
  const leftHours = (visStart - start) / 3600 / 1000;
  const widthHours = (visEnd - visStart) / 3600 / 1000;
  const style = BLACKOUT_ROLE_STYLE[blackout.created_by_role] || BLACKOUT_ROLE_STYLE.default;
  return (
    <div
      className="absolute pointer-events-none"
      style={{
        left: left + leftHours * pxPerHour,
        width: widthHours * pxPerHour,
        top: top,
        height: fullHeight,
        backgroundColor: style.bg,
        boxShadow: `inset 0 0 0 1px ${style.ring}`,
      }}
      title={blackout.title || blackout.reason || "Site-wide closure"}
    />
  );
}

